<template>
  <th
    ref="tableHeading"
    class="items-center text-base font-medium text-primary-purple-600 capitalize sticky -top-px bg-primary-purple-100 z-[2]"
  >
    <div
      class="w-full border-l border-r border-primary-white h-12.5 items-center flex lg:px-6 px-3.5 min-w-[140px]"
    >
      <slot />
    </div>
  </th>
</template>

<script setup>
import { onMounted, ref } from 'vue'

const tableHeading = ref(null)

onMounted(() => {
  if (tableHeading.value.innerText === 'Actions') {
    tableHeading.value.classList.add('w-35')
  }
})
</script>
